import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  ListItem,
  ListItemText,
  Avatar,
  Divider,
} from '@material-ui/core';
import Warning from '@material-ui/icons/Warning';

export const ConfirmDeactivateOrganizationModalComponent = ({
  isOpen,
  handleClose,
  handleCloseConfirm,
}) => (
  <div>
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="confirm-deactivation-dialog-title"
      aria-describedby="confirm-deactivation-dialog-description"
    >
      <DialogTitle id="confirm-deactivation-dialog-title">Confirm Deactivation of Organization</DialogTitle>
      <DialogContent id="confirm-deactivation-dialog-description">
        <ListItem>
          <Avatar style={{ color: 'red' }}>
            <Warning />
          </Avatar>
          <ListItemText primary="Are you sure you want to deactivate this organization" secondary="The following actions will take place after confirmation of deactivation." />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary="If your organization is on a paid plan, you will be removed from that subscription." secondary="In addition, a credit for the remainder of your current billing cycle will be placed on your account." />
        </ListItem>
        <ListItem>
          <ListItemText primary="All credit cards on file will be removed." />
        </ListItem>
        <ListItem>
          <ListItemText primary="No users will be able to access this organization from their organization page, or from the direct link to the organization." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Access to the organization in the website, mobile application, and from the APIs will be restricted." />
        </ListItem>
        <ListItem>
          <ListItemText primary="To reactive this organization contact support." />
        </ListItem>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button onClick={handleCloseConfirm} color="secondary" variant="contained">
          Confirm Deactivation
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);

ConfirmDeactivateOrganizationModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleCloseConfirm: PropTypes.func,
};

ConfirmDeactivateOrganizationModalComponent.defaultProps = {
  isOpen: false,
  handleClose: () => {},
  handleCloseConfirm: () => {},
};

export default ConfirmDeactivateOrganizationModalComponent;
